import {
  Box,
  Fade,
  Modal,
  Paper,
  TextField,
  Typography,
  IconButton,
  Button,
  Autocomplete,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { AddBox } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { useEffect, useState, useMemo } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { createAccountGroupMaster, updateAccountGroupMaster } from '../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  width: { xs: '80vw', md: '50vw' },
};
const NewAddPartyGroup = ({ open, setOpen, viewOpen, setNewGp, options, getAccountData, editData, setEditData, data }) => {
  const [errorBool, setErrorBool] = useState(false);
  const [groupName, setGroupName] = useState(editData?.label ? editData?.label : '');
  const [backdropOpen, setBackdropOpen] = useState(false);

  // Function to flatten tree and get all existing group values
  const getExistingGroupValues = (tree) => {
    const existingValues = new Set();

    const flattenTree = (nodes) => {
      if (!nodes || !Array.isArray(nodes)) return;
      nodes.forEach((node) => {
        if (node?.value !== undefined && node?.value !== null) {
          // Convert to string for consistent comparison
          existingValues.add(String(node.value));
        }
        if (node?.children && Array.isArray(node.children)) {
          flattenTree(node.children);
        }
      });
    };

    flattenTree(tree);
    return existingValues;
  };

  // Function to recursively find all children node values
  const getAllChildrenValues = (parentValue, allOptions) => {
    const childrenValues = new Set();

    const findChildren = (parentId) => {
      const children = allOptions.filter((op) => op.pgID == parentId);
      children.forEach((child) => {
        childrenValues.add(child.value);
        findChildren(child.value); // Recursively find grandchildren
      });
    };

    findChildren(parentValue);
    return childrenValues;
  };

  // Filter options to only include groups that exist in the current data tree
  const validOptions = useMemo(() => {
    // Always filter based on data if available
    if (data && Array.isArray(data)) {
      const existingGroupValues = getExistingGroupValues(data);
      // Convert option values to string for consistent comparison
      return (options || []).filter((op) => {
        if (op?.value === undefined || op?.value === null) return false;
        return existingGroupValues.has(String(op.value));
      });
    }
    // Fallback: return all options if data is not available
    // This should rarely happen as data should always be provided
    return options || [];
  }, [data, options]);

  const partyGps = useMemo(() => {
    if (editData?.value) {
      // Get all children node values of the particular element being edited
      const childrenValues = getAllChildrenValues(editData.value, validOptions);

      // Filter out: current item and its children nodes only
      return validOptions.filter((op) => {
        return op.value != editData.value && !childrenValues.has(op.value);
      });
    }
    return validOptions;
  }, [editData, validOptions]);

  // Initialize group with editData or first valid option
  const getInitialGroup = () => {
    if (editData?.pgID) return editData.pgID;
    const filtered = data
      ? options.filter((op) => {
          const existingValues = getExistingGroupValues(data);
          return existingValues.has(op.value);
        })
      : options;
    return filtered[0]?.value;
  };

  const [group, setGroup] = useState(getInitialGroup);

  // Reset group and groupName when modal opens/closes or editData changes
  useEffect(() => {
    if (open) {
      if (editData?.value) {
        // Edit mode: use editData values
        setGroup(editData.pgID || validOptions[0]?.value);
        setGroupName(editData.label || '');
      } else {
        // Add mode: reset to defaults
        setGroup(validOptions[0]?.value);
        setGroupName('');
        setErrorBool(false);
      }
    }
  }, [open]);

  // // Update group when validOptions changes (e.g., after deletion)
  // useEffect(() => {
  //   if (!editData?.pgID && validOptions.length > 0 && !validOptions.find((op) => op.value == group)) {
  //     setGroup(validOptions[0]?.value);
  //   } else if (editData?.pgID) {
  //     // Make sure editData's pgID exists in validOptions
  //     const isValidParent = validOptions.find((op) => op.value == editData.pgID);
  //     if (isValidParent) {
  //       setGroup(editData.pgID);
  //     } else if (validOptions.length > 0) {
  //       setGroup(validOptions[0]?.value);
  //     }
  //   }
  // }, [validOptions, e]);

  console.log(partyGps, 'partyGps');

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setEditData('');
    }
  };
  async function createPartyGroup(data) {
    setBackdropOpen(true);
    try {
      if (!editData) {
        const res = await API.graphql(
          graphqlOperation(createAccountGroupMaster, {
            createAccountGroupMasterInput: data,
          })
        );
        if (res?.data?.createAccountGroupMaster.statuscode === 'SUCCESS') {
          setNewGp(res?.data?.createAccountGroupMaster.accountgroupid);
          setOpen(false);
          viewOpen(false);
          showSuccessSnackbar('Group Created Successfully');
          getAccountData();
        } else {
          showWarningSnackbar(res?.data?.createAccountGroupMaster?.statusmessage);
        }
      } else {
        const res = await API.graphql(
          graphqlOperation(updateAccountGroupMaster, {
            updateAccountGroupMasterInput: data,
          })
        );

        if (res?.data?.updateAccountGroupMaster?.statuscode == 'Success') {
          setOpen(false);
          viewOpen(false);
          showSuccessSnackbar(res?.data?.updateAccountGroupMaster?.statusmessage);
          getAccountData();
          setEditData('');
        } else {
          showWarningSnackbar(res?.data?.updateAccountGroupMaster?.statusmessage);
        }
      }
    } catch (error) {
      if (error) {
        const rawMessage = error?.errors[0]?.message?.split('RDSHttp:')[1];
        const parsedMessage = JSON.parse(rawMessage)?.message;
        const errorMessage = parsedMessage?.split('ERROR: ')[1]?.split(';')[0];
        showWarningSnackbar(errorMessage);
      }
    }
    setBackdropOpen(false);
  }
  console.log(options, editData, 'options');

  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        if (errorBool || groupName === '') {
          e.preventDefault();
        } else {
          e.preventDefault();
          addGroup();
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [group, groupName]);

  const addGroup = () => {
    const groupData = {
      accountgroupname: groupName,
      accountparentgroupid: group,
      accounttypecd: 'BS',
    };
    const updateData = {
      accountgroupid: Number(editData?.value),
      accountgroupname: groupName,
      companybranchid: 0,
      accountparentgroupid: Number(group),
      accounttypecd: 'BS',
      is_active: 1,
    };
    if (editData) {
      createPartyGroup(updateData);
    } else {
      createPartyGroup(groupData);
    }
  };
  return (
    <Modal
      id={open ? 'addPartyGroup' : ''}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ color: '#fff', display: 'flex' }}>
                  {' '}
                  <AddBox fontSize="small" sx={{ marginRight: '5px' }} /> {editData?.value ? 'Edit Group' : 'New Group'}
                </Typography>
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '15px',
            }}
          >
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: { xs: 1 }, m: 1 }}>
                <TextField
                  name="group"
                  placeholder="Group"
                  size="small"
                  type="text"
                  fullWidth
                  value={groupName}
                  required={true}
                  inputProps={{
                    maxLength: 50,
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData('text');
                    if (pastedText.length > 50) {
                      showWarningSnackbar('Text above 50 characters not allowed. Excess characters will be removed.');
                      const truncatedText = pastedText.substring(0, 50);
                      // Capitalize first letter of each word
                      const capitalized = truncatedText ? truncatedText.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
                      setGroupName(capitalized);
                      const data = validOptions.find((op) => op.label.toLowerCase() == capitalized.trim().toLowerCase());
                      if (data) {
                        setErrorBool(true);
                      } else {
                        setErrorBool(false);
                      }
                    } else {
                      // If within limit, allow normal paste behavior
                      const capitalized = pastedText ? pastedText.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
                      setGroupName(capitalized);
                      const data = validOptions.find((op) => op.label.toLowerCase() == capitalized.trim().toLowerCase());
                      if (data) {
                        setErrorBool(true);
                      } else {
                        setErrorBool(false);
                      }
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.value.trim().length <= 50) {
                      // Capitalize first letter of each word
                      const capitalizedValue = e.target.value;
                      const capitalized = capitalizedValue ? capitalizedValue.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
                      setGroupName(capitalized);
                      const data = validOptions.find((op) => op.label.toLowerCase() == capitalized.trim().toLowerCase());
                      if (data) {
                        setErrorBool(true);
                      } else {
                        setErrorBool(false);
                      }
                    } else {
                      // If typing exceeds 50, truncate and show warning
                      showWarningSnackbar('Text above 50 characters not allowed. Excess characters will be removed.');
                      const truncatedValue = e.target.value.substring(0, 50);
                      const capitalized = truncatedValue ? truncatedValue.replace(/\b\w/g, (l) => l.toUpperCase()) : '';
                      setGroupName(capitalized);
                      const data = validOptions.find((op) => op.label.toLowerCase() == capitalized.trim().toLowerCase());
                      if (data) {
                        setErrorBool(true);
                      } else {
                        setErrorBool(false);
                      }
                    }
                  }}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                />
                {console.log(group, 'group')}
                <Autocomplete
                  fullWidth
                  sx={{ marginTop: '10px' }}
                  getOptionLabel={(option) => option?.label}
                  value={validOptions?.find((op) => op?.value == group) || null}
                  onChange={(event, newValue) => {
                    console.log(group, validOptions, 'validOptions');
                    setGroup(newValue.value);
                  }}
                  size="small"
                  options={partyGps}
                  renderInput={(params) => <TextField {...params} fullWidth label="Under Parent Group" />}
                />
                {errorBool ? (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '12px',
                      color: 'danger.main',
                    }}
                  >
                    Group exists
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      padding: '10px',
                      fontSize: '12px',
                      color: 'danger.main',
                    }}
                  ></Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
              Cancel
            </Button>
            <LoadingButton
              sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
              variant="contained"
              onClick={addGroup}
              disabled={errorBool || groupName === ''}
              className={`${!errorBool && groupName !== '' ? 'saveButton' : ''}`}
            >
              {editData ? 'Update' : 'Save'}
            </LoadingButton>
          </Box>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default NewAddPartyGroup;
